<template>
  <vx-card class="px-4">
    <!-- MAIL HEAD -->
    <div class="vx-row">
      <div
        class="vx-col w-full border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid flex justify-between flex items-center">
        <!-- Sender Details -->
        <div class="flex items-center">
          <div>
            <vs-avatar :src="userPhoto"
                       class="sender__avatar--single flex-shrink-0 mr-3 border-2 border-solid border-white"
                       size="65px"/>
          </div>

          <div class="flex flex-col">
            <h5 class="mb-1">{{ userName }}</h5>
            <div class="flex items-center">
              <span class="text-sm">{{ courseName }}</span>
            </div>
          </div>
        </div>
        <!-- /Sender Details -->

        <!-- Mail Time & Date -->
        <div class="flex flex-col justify-end">
          <span class="text-right">{{ mailContent.sendDate | time }}</span>
          <div class="flex justify-end mt-2">
            <span class="text-right">{{ mailContent.sendDate | date(true) }}</span>
          </div>
        </div>
      </div>
      <!-- /Mail Time & Date -->
    </div>

    <!-- MAIL CONTENT -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mail__content break-words mt-8 mb-4" v-html="mailContent.message"></div>
      </div>
    </div>

  </vx-card>
</template>

<script>
  import {getAvatarUrl} from "../../../../utils/upload";

  export default {
    props: [
      'mailContent',
      'classSection',
      'courseOutlineRegistration',
    ],
    computed: {
      userPhoto() {
        if (this.mailContent) {
          return getAvatarUrl(this.mailContent.fromUser.photo)
        }
        return ''
      },
      userName() {
        if (this.mailContent) {
          return `${this.mailContent.fromUser.code} ${this.mailContent.fromUser.nameLocal} ${this.mailContent.fromUser.surnameLocal}`
        }
        return ''
      },
      courseName() {
        if (this.courseOutlineRegistration && this.classSection) {
          return `${this.courseOutlineRegistration.subjectCode} ${this.$t('pm.section-no')} ${this.classSection.sectionNo}`
        }
        return ''
      }
    }
  }
</script>
